/* Package-card enhancement only; PDP pages are deliberately excluded. */
(() => {
  const interactive = 'a,button,input,select,textarea,label,summary,details,[role="button"],[contenteditable="true"]';
  function init(root = document) {
    root.querySelectorAll('.ff-home .ff-folio-product, .ff-collection .ffc-card.ff-edit-card').forEach(card => {
      if (card.dataset.ffCardReady) return;
      const link = card.querySelector('.ff-card-title-link');
      if (!link) return;
      card.dataset.ffCardReady = 'true';
      const rail = card.closest('.ff-folio-carousel-window,[data-ff-shop-how-rail]');
      let gesture = null;
      card.addEventListener('pointerdown', e => {
        gesture = {id:e.pointerId,x:e.clientX,y:e.clientY,scroll:rail?.scrollLeft || 0,moved:false};
      }, {passive:true});
      card.addEventListener('pointermove', e => {
        if (gesture?.id === e.pointerId && Math.hypot(e.clientX-gesture.x,e.clientY-gesture.y)>10) gesture.moved=true;
      }, {passive:true});
      card.addEventListener('pointercancel', () => {if(gesture) gesture.moved=true;}, {passive:true});
      card.addEventListener('dragstart', () => {if(gesture) gesture.moved=true;});
      card.addEventListener('click', e => {
        const moved = gesture && (gesture.moved || Math.hypot(e.clientX-gesture.x,e.clientY-gesture.y)>10 || Math.abs((rail?.scrollLeft || 0)-gesture.scroll)>10);
        if (e.detail !== 0 && moved) {e.preventDefault();e.stopPropagation();return;}
        if (e.target.closest(interactive) || e.defaultPrevented || e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey || window.getSelection()?.toString().trim()) return;
        link.click();
      }, true);
    });
  }
  if(document.readyState === 'loading')document.addEventListener('DOMContentLoaded',()=>init());else init();
  document.addEventListener('shopify:section:load', e=>init(e.target));
})();
